import { render, staticRenderFns } from "./gelenfaturalistesi.vue?vue&type=template&id=18acb901"
import script from "./gelenfaturalistesi.vue?vue&type=script&lang=js"
export * from "./gelenfaturalistesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports